import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, getCurrentInstance, onBeforeUnmount, onMounted, ref} from 'vue';
import PerfectScrollbar from './PerfectScrollbar.js';
import {ConfigStore} from "~/chat/ts/store/Config";
import Delay from "~/ts/library/Delay";



const __default__ = {
    name: "ChatScrollContainer"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    enabled: { type: Boolean, default: true }
  },
  emits: ["scroll", "scroll-bottom", "scroll-top", "scroll-middle"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let ps = ref<any>();
let observer: MutationObserver;

let isForceNative = computed(() => {
    return ConfigStore.isMobile.value || ConfigStore.isIe.value;
});

let className = computed(() => {
    let result: string[] = [
        "chat-scroll-container"
    ];
    if (props.enabled && isForceNative.value) {
        result.push("native");
    }
    return result;
});

async function onScroll(e: CustomEvent) {
    emits("scroll", e);

    try {
        await Delay.make(50, "onChatContainerScroll", true);
        let element = e.target as HTMLElement;
        let isScrolledToBottom = Math.ceil(element.scrollTop) + Math.ceil(element.offsetHeight) >= Math.ceil(element.scrollHeight);
        if (isScrolledToBottom || Math.ceil(element.offsetHeight) >= Math.ceil(element.scrollHeight) - 1) {
            emits("scroll-bottom");
        } else {
            emits("scroll-middle");
        }
        if (element.scrollTop == 0) {
            emits("scroll-top");
        }
    } catch (e) {

    }
}

let instance = getCurrentInstance().proxy;

onMounted(async () => {
    if (props.enabled) {
        if (!isForceNative.value) {
            ps.value = new PerfectScrollbar(instance.$el, {
                wheelPropagation: false,
                suppressScrollX: true
            });
            observer = new MutationObserver(() => {
                ps.value.update();
            });
            observer.observe(instance.$el, {
                childList: true,
                subtree: true
            });
        } else {

        }
    }
});

onBeforeUnmount(() => {
    if (observer) {
        observer.disconnect();
    }
    ps.value?.destroy();
    ps.value = null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(className)),
    onScrollPassive: onScroll
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 34))
}
}

})